export const referralLinkPlaceholder = '{{ referral_link }}';
export const referralCodePlaceholder = '{{ referral_code }}';
